import React from 'react';
import {
  IonButton,
  IonRow,
  IonCol,
  IonText
} from '@ionic/react';
import { Card, Text } from '@tremor/react';
import { extractNumber, formatAmount } from '../../../utils/numberFormat';

const CreditCardPayment = ({
  amount,
  onCreditCardPayment,
  onCancelSubscription
}) => {
  const cleanAmount = extractNumber(amount);

  return (
    <Card
      style={{
        borderRadius: '10px',
        padding: '1rem',
      }}
    >
      <IonText className="ion-text-start">
        <h3>Payment Instructions</h3>
      </IonText>

      <Text className="ion-margin-top ion-margin-bottom" color="gray">
        Payments are securely processed by a trusted third-party gateway that protects your details.
      </Text>

      <IonText className="ion-margin-bottom">
        <span className="font-semibold">Amount:</span>{' '}
        <strong>KES {formatAmount(cleanAmount)}</strong>
      </IonText>

      <IonRow>
        <IonCol size="12" sizeMd="6">
          <IonButton
            expand="block"
            className="ion-margin-top"
            color="primary"
            onClick={onCreditCardPayment}
          >
            Subscribe
          </IonButton>
        </IonCol>
        <IonCol size="12" sizeMd="6">
          <IonButton
            expand="block"
            className="ion-margin-top"
            fill="outline"
            color="primary"
            onClick={onCancelSubscription}
          >
            Cancel Subscription
          </IonButton>
        </IonCol>
      </IonRow>

      <IonText className="ion-text-center">
        <p className="ion-margin-top">
          Once you complete paying, click the Done button below.
        </p>
      </IonText>
    </Card>
  );
};

export default CreditCardPayment;
